<div class="asset-side-menu section dark">
  <div class="side-menu-header">
    <div class="header-toggle" [class.active]="mode === 'info'" (click)="mode !== 'info' && switchMode('info')">
      <span>Information</span><span class="hidden">Information</span>
    </div>
    @if (galleryPermissions()?.can_review_if_authenticated) {
      <div
        class="header-toggle"
        [class.active]="mode === 'activity'"
        data-test-id="activity-toggle"
        (click)="mode !== 'activity' && switchMode('activity')"
      >
        <span>Comments</span><span class="hidden">Comments</span>
      </div>
    }
    <div class="spacer"></div>
    <button
      appButton
      name="close"
      shape="round"
      location="asset-sidebar"
      [iconButton]="true"
      (click)="close()"
      color="hard-simple"
    >
      @if (isDesktop) {
        <app-svg src="/assets/icons/slide-right.svg"></app-svg>
      } @else {
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      }
    </button>
  </div>
  <ng-content></ng-content>
</div>
